// src/services/queries/mediaInsights/insights.ts

import type { QueryFunction } from "@tanstack/react-query";
import { queryKeys } from "@/constants/queryKeys";
import { TIME } from "@/constants/app";
import { API_BASE_URL } from "@/services/";
import type { Channel } from "@/pages/youtube-insights/types";

export interface GetAllChannelsResponse {
  data: Channel[];
}

/**
 * Fetch all channels data (GET request)
 */
export const fetchAllChannels: QueryFunction<GetAllChannelsResponse> = async ({
  signal,
}) => {
  const response = await fetch(
    `${API_BASE_URL}/multimediaInsightPage/getAllChannels`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      signal,
    }
  );

  if (!response.ok) {
    const text = await response.text();
    throw new Error(
      `Get all channels request failed (${response.status}): ${
        text || response.statusText
      }`
    );
  }

  return response.json();
};

// ============= Query Options Factory =============
export const getAllChannelsQueryOptions = () => ({
  queryKey: queryKeys.mediaInsights.allChannels(),
  queryFn: fetchAllChannels,
  staleTime: 12 * TIME.HOUR,
  gcTime: 24 * TIME.HOUR,
  retry: (failureCount: number, error: Error) => {
    if (error.message.includes("4")) {
      return false;
    }
    return failureCount < 3;
  },
  refetchOnWindowFocus: false,
});
